module.exports = __webpack_public_path__ + "media/butch.3efd3a68.webm";